(() => {
  const SELECTOR = 'slider-component[data-auto-slider="true"]';

  function getStep(slider) {
    return Math.max(1, slider.slidesPerPage || 1);
  }

  function advance(slider) {
    if (!slider.slider || !slider.sliderItemOffset) return;

    const step = getStep(slider);
    const maxScroll = slider.slider.scrollWidth - slider.slider.clientWidth;
    const next = slider.slider.scrollLeft + step * slider.sliderItemOffset;

    slider.setSlidePosition(next >= maxScroll - 4 ? 0 : next);
  }

  function syncButtonStep(slider) {
    const step = String(getStep(slider));
    slider.prevButton?.setAttribute('data-step', step);
    slider.nextButton?.setAttribute('data-step', step);
  }

  function init(el) {
    if (el.dataset.autoSliderBound === 'true') return;
    el.dataset.autoSliderBound = 'true';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const speed = Math.max(3, Number(el.dataset.autoSliderSpeed) || 5) * 1000;
    let timer = null;

    const start = () => {
      stop();
      timer = window.setInterval(() => advance(el), speed);
    };

    const stop = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    const refresh = () => {
      el.initPages?.();
      syncButtonStep(el);
    };

    refresh();
    start();

    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);
    el.addEventListener('focusin', stop);
    el.addEventListener('focusout', start);
    el.addEventListener('touchstart', stop, { passive: true });
    el.addEventListener('touchend', start, { passive: true });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    });

    window.addEventListener('resize', refresh, { passive: true });
  }

  function boot() {
    document.querySelectorAll(SELECTOR).forEach(init);
  }

  if (window.customElements?.whenDefined) {
    customElements.whenDefined('slider-component').then(boot);
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
